<template>
	<b-modal
		v-model="showModal"
		title="Columns"
		body-class="py-0 px-4"
		footer-class="p-4"
		size="xl"
		class="drv-modal"
	>
		<div
			class="mb-4 d-flex justify-content-between align-items-center small"
		>
			<div class="d-flex align-items-center">
				<a
					v-if="selection.length < cpFields.length"
					@click.prevent="selectAll"
					href
					>Select All</a
				>
				<span
					v-if="
						selection.length && selection.length < cpFields.length
					"
					class="mx-2"
					>|</span
				>
				<a v-if="selection.length" @click.prevent="clearSelection" href
					>Clear</a
				>
				<template v-if="searchKeyword">
					<span
						v-if="
							selection.length ||
							selection.length < cpFields.length
						"
						class="mx-2"
						>|</span
					>
					<a @click.prevent="resetColumns" href>View All Columns</a>
				</template>
			</div>

			<DrvSearchBar v-model="searchKeyword" class="ml-auto" is-single />
		</div>

		<b-form-checkbox-group
			v-if="cpFields.length"
			v-model="selection"
			:options="cpFields"
			class="drv-checkbox-grid"
			stacked
		></b-form-checkbox-group>
		<p v-else class="m-0 small">No items found.</p>

		<template #modal-footer>
			<b-button
				@click.prevent.stop="clearSelection"
				variant="primary"
				outlined
				>Clear</b-button
			>
			<b-button
				@click.prevent.stop="showModal = !showModal"
				variant="primary"
				class="ml-auto"
				>Save</b-button
			>
		</template>
	</b-modal>
</template>

<script>
import Fuse from "fuse.js";

import DrvSearchBar from "./DrvSearchBar.vue";

export default {
	name: "drv-columns-modal",
	props: {
		fields: {
			type: Array,
			default() {
				return [];
			},
		},
	},
	components: {
		DrvSearchBar,
	},
	data() {
		return {
			showModal: false,
			searchKeyword: null,
			selection: [],
		};
	},
	computed: {
		cpFields() {
			let fields = this.fields.map((item) => {
				return {
					text:
						"string" === typeof item
							? item.replace(/_/g, " ")
							: item.label || item.key,
					value: "string" === typeof item ? item : item.key,
				};
			});
			const fuse = new Fuse(fields, {
				keys: ["text"],
				useExtendedSearch: true,
			});

			if (this.searchKeyword)
				fields = fuse
					.search(`'${this.searchKeyword}`)
					.map((item) => item.item);

			return fields;
		},
	},
	watch: {
		selection: {
			immediate: true,
			handler(newVal) {
				this.$emit("toggle-columns", newVal);
			},
		},
	},
	methods: {
		resetColumns() {
			this.searchKeyword = null;
		},
		selectAll() {
			const values = this.cpFields.map((item) => item.value);

			this.selection = values;
		},
		clearSelection() {
			this.selection = [];
		},
	},
	mounted() {
		this.selectAll();

		this.$on("show", (payload) => {
			this.showModal = payload;
		});
	},
};
</script>
